import axios from 'axios'
import AgreementContragent from './itemContragent.js'
import AgreementRequest from './itemRequest.js'

export default class item {
  constructor(code) {
    this._code = code;
    this._loading = false;
    this._data = {
      country: '',
      startDate: '',
      mask: '',
      reason: '',
      date: new Date().toStringRu(),
      currency: 0,
      bonus: 0,
      edit: false,
    };
    this._filter = {
      direction: 0,
      contragentType: 1,
      contragent: 0,
      legal: 0,
      currency: 1,
    };
    this._contragents = [];
    this._requests = [];
  }

  get code() {
    return this._code;
  }

  set code(value) {
    this._code = value;
  }

  get loading() {
    return this._loading || !!this._requests.find(i => i.loading);
  }

  set loading(value) {
    this._loading = value;
  }

  get data() {
    return this._data;
  }

  set data(data) {
    this._data.reason = '';
    this._data.bonus = data.BonusesData.MaxPayment;
    this._data.currency = data.PaymentsData.AgreementCurrencyId;
    this._data.country = data.ClientContractorsData.CountryName;
    this._data.startDate = data.ClientContractorsData.StartDate.Serialized;
    this._contragents = AgreementContragent.setContragents(data);
    this._requests = AgreementRequest.setRequests(data);
    this.setFilterRequests();
    this.setReason();
  }

  get date() {
    return this._data.date;
  }

  set date(value) {
    this._data.date = value;
  }

  get bonus() {
    return this._data.bonus;
  }

  set bonus(value) {
    this._data.bonus = value;
  }

  get mask() {
    return this._data.mask;
  }

  set mask(value) {
    this._data.mask = value;
    this.setReason();
  }

  get edit() {
    return this._data.edit;
  }

  set edit(value) {
    this._data.edit = value;
  }

  get reason() {
    return this._data.reason;
  }

  set reason(value) {
    this._data.reason = value;
  }

  get contragents() {
    return this._contragents.filter(i => i.type === this._filter.contragentType);
  }

  get legals() {
    const contragent = this.contragents.find(i => i.value === this._filter.contragent);
    return contragent ? contragent.legals : [];
  }

  get requests() {
    if (this._filter.contragentType === 3) return this._requests.filter(i => i.legal === this._filter.legal);
    else if (this._filter.contragentType === 2) return this._requests.filter(i => i.type === 1);
    else return this._requests.filter(i => i.type === this._filter.contragentType);
  }

  get direction() {
    return this._filter.direction;
  }

  set direction(value) {
    this._filter.direction = value;
    this.setFilterRequests();
  }

  get contragentType() {
    return this._filter.contragentType;
  }

  set contragentType(value) {
    this._filter.contragentType = value;
    this.setFilterRequests();
  }

  get contragent() {
    return this._filter.contragent;
  }

  set contragent(value) {
    this._filter.contragent = value;
    this.setFilterRequests();
  }

  get legal() {
    return this._filter.legal;
  }

  set legal(value) {
    this._filter.legal = value;
    this.setFilterRequests();
  }

  get currency() {
    return this._filter.currency;
  }

  set currency(value) {
    this._filter.currency = value;
    this.setFilterRequests();
  }

  get ajaxData() {
    const self = this;
    return (self.requests.find(request => request.value)) ? {
      Code: self.code,
      // Spread: self.requests.reduce((sum, request) => Math.round(sum * 1000000000000 + request.value * 1000000000000) / 1000000000000, 0),
      Date: {Serialized: (new Date()).toStringRu(), Format: "dd.MM.yyyy"},
      Comment: self.reason,
      OrderPrices: self.requests.filter(request => request.value).map(request => {
        return {
          RequestId: request.id,
          Spread: request.value,
          TargetCurrencyId: request.currency,
          Course: request.course,
        }
      })
    } : null;
  }

  get sum() {
    return this.requests.reduce((sum, request) => Math.round(sum * 1000000000000 + request.value * 1000000000000) / 1000000000000, 0);
  }

  get() {
    const self = this;
    return new Promise((resolve, reject) => {
      self._loading = true;
      axios
        .get(`/tourclient/payment/contractorPayments?Code=${encodeURIComponent(self.code)}&_${new Date().getTime()}`)
        .then(({data}) => {
          if (!data) return reject('Не удалось получить данные с сервера');
          if (data.PaymentsData.ResultQueryInfo && data.PaymentsData.ResultQueryInfo.HasError) return reject(data.PaymentsData.ResultQueryInfo.UserMessages);
          if (data.ClientContractorsData && data.ClientContractorsData.IsPreorder) return reject(`№${self.code} является предзаказом и недоступен для оплаты`);
          self.data = data;
          resolve(self);
        }, () => reject('Не удалось получить данные с сервера'))
        .finally(() => {
          self._loading = false;
        })
    });
  }

  setFilters({direction, contragentType, contragent, legal, currency}) {
    const self = this;
    return new Promise((resolve, reject) => {
      // const newCourse = self._filter.currency !== currency;
      // const newSum = self._filter.contragentType !== contragentType || self._filter.direction !== direction || self._filter.contragent !== contragent || self._filter.legal !== legal;
      self._filter.direction = direction;
      self._filter.contragentType = contragentType;
      self._filter.contragent = contragent;
      self._filter.legal = legal;
      self._filter.currency = currency;
      self.setFilterRequests();
      if (self.edit) return resolve();
      self.getCourses(self.usePartnerCourse).then(() => {
        self.setSum();
        self.setReason();
        resolve();
      });
    });
  }

  setFilterRequests() {
    this._requests.forEach(request => {
      request.filter = this._filter;
    });
  }

  setReason() {
    if (this.edit) return;
    let reason = '';
    const contragent = this._contragents.find(i => i.value === this.contragent);
    const legal = contragent ? contragent.legals.find(i => i.value === this.legal) : null;
    const dateNow = (new Date()).toStringRu();
    const datePay = (new Date()).toStringRu();
    const dateBeg = this._data.startDate;
    const country = this._data.country;
    const requests = this.requests.reduce((val, request) => val + (val ? ', ' : '') + request.label, '');
    const operators = this._contragents.filter(i => i.type === 3).reduce((val, contragent) => val + (val ? ', ' : '') + contragent.label, '');
    const tourists = this._contragents.filter(i => i.type === 1).reduce((val, contragent) => val + (val ? ', ' : '') + contragent.label, '');
    const operatorLegals = this._contragents
      .filter(i => i.type === 3)
      .reduce((arr, contragent) => {
        arr.concat(contragent.legals);
        return arr;
      }, [])
      .reduce((val, legal) => val + (val ? ', ' : '') + legal.label, '');
    reason = this._data.mask || '';
    reason = reason.replace(/{code}/g, this.code);
    reason = reason.replace(/{datebeg}/g, dateBeg);
    reason = reason.replace(/{request}/g, requests);
    reason = reason.replace(/{operator}/g, operators);
    reason = reason.replace(/{operatorlegal}/g, operatorLegals);
    reason = reason.replace(/{tourist}/g, tourists);
    reason = reason.replace(/{contragent}/g, contragent ? contragent.label : '');
    reason = reason.replace(/{contragentlegal}/g, legal ? legal.label : '');
    reason = reason.replace(/{datenow}/g, dateNow);
    reason = reason.replace(/{datepay}/g, datePay);
    // reason = reason.replace(/{debt}/g, d.debt);
    // reason = reason.replace(/{clientdebt}/g, d.clientdebt);
    // reason = reason.replace(/{operatordebt}/g, d.operatordebt);
    reason = reason.replace(/{country}/g, country);
    this.reason = reason;
  }

  getCourses(usePartnerCourse = true) {
    let self = this;
    return new Promise((resolve, reject) => {
      let arr = self._requests.map(i => i.getCourse(self._data.date, usePartnerCourse, i.contragent));
      Promise.all(arr).then(resolve, reject);
    });
  }

  setSum() {
    if (this.edit) return;
    this.requests.forEach(request => {
      request.value2 = request.debt
    })
  }
}
